import {
  useQueryClient,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";

import { API_ACTIVATE_FACTOR_URL } from "constants/apiUrls";

import { QueryKey } from "types/queryKey/queryKey";
import { Factor } from "types/factor/factor";
import { OktaError } from "types/oktaError/oktaError";

import useGetApiClient from "./useGetApiClient";

export type ActivateFactorData = {
  factorId: string;
  passCode: string;
};

function useActivateFactor(): UseMutationResult<
  Factor,
  OktaError,
  ActivateFactorData
> {
  const queryClient = useQueryClient();
  const apiClient = useGetApiClient();

  return useMutation({
    mutationFn: async (data) => {
      const response = await apiClient(API_ACTIVATE_FACTOR_URL, {
        method: "POST",
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return await queryClient.fetchQuery([QueryKey.AllFactors]);
      }
    },
  });
}

export default useActivateFactor;
